/**
 * Chrome has reported its version as `<major>.0.0.0` since 101, so a bare
 * Chrome user agent carrying a build number is not Chrome (measured volumes:
 * DATA-420). Anchored on purpose: embedded Chromium reports a populated build
 * too, and is only distinguishable by the product token it appends.
 * Three-digit major only, because a build number is honest before the version
 * reduction landed in 101.
 *
 * @see ./index.test.ts for the embedded-Chromium clients this must not match
 */
export const BARE_LINUX_CHROME =
  /^Mozilla\/5\.0 \(X11; Linux x86_64\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/\d{3,}\.\d+\.\d+\.\d+ Safari\/537\.36$/

/**
 * Real Chrome matches the bare shape above, so excluding the reduced version is
 * what keeps it tracked.
 */
export const REDUCED_CHROME_VERSION = /Chrome\/\d+\.0\.0\.0\b/

/**
 * Matched in full rather than by widening the shape test above by platform,
 * which was measured and would drop real signed-in users on Windows and Mac
 * (DATA-421, DATA-459).
 */
export const CHROME98_LINUX_BOT =
  'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.102 Safari/537.36'
export const CHROME133_WINDOWS_BOT =
  'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/133.0.6943.141 Safari/537.36'

/**
 * For services that render per request. Callers that must serialize the check
 * into a browser snippet — because their pages are CDN-cached and cannot see
 * the user agent at render time — use the patterns above instead.
 */
export function isForgedBrowserUa(userAgent: string): boolean {
  if (userAgent === CHROME98_LINUX_BOT || userAgent === CHROME133_WINDOWS_BOT) {
    return true
  }

  return (
    BARE_LINUX_CHROME.test(userAgent) && !REDUCED_CHROME_VERSION.test(userAgent)
  )
}
